import request from '@/utils/request'
import { menuCodeHeaders, ScheduleMenuCode } from '@/utils/menuCodeHeaders'
import {
  BulkUpdateCutOffScheduleStatusReq,
  CreateCutOffScheduleReq,
  DeleteCutOffScheduleReq,
  GetOutboundSchedulesReq,
  GetOutboundSchedulesRes,
  GetOverseasPriorityRes,
  SetAllocationPriorityReq,
  SetOverseasPriorityReq,
  UpdateCutOffScheduleStatusReq,
} from './types'

/** 일자별 출고 일정 조회 */
export const getOutboundSchedules = (params: GetOutboundSchedulesReq) =>
  request.post<ApiResponseV2<GetOutboundSchedulesRes>, GetOutboundSchedulesReq>('/api/v1/get-schedules-grid', params)

/** 컷오프 일정 생성  */
export const createCutOffSchedule = (params: CreateCutOffScheduleReq) => request.post('/api/v1/create-schedule', params)

/** 컷오프 일정 삭제 */
export const deleteCutOffSchedule = (params: DeleteCutOffScheduleReq) => request.post('/api/v1/delete-schedule', params)

/** 컷오프 일정 상태 업데이트 */
export const updateCutOffScheduleStatus = (params: UpdateCutOffScheduleStatusReq) => request.post('/api/v1/update-schedule-status', params)

/** 컷오프 일정 일괄 상태 업데이트 */
export const bulkUpdateCutOffScheduleStatus = (params: BulkUpdateCutOffScheduleStatusReq) =>
  request.post('/api/v1/bulk-update-schedules-status', params)

/** 할당 우선순위 설정 */
export const setAllocationPriority = (params: SetAllocationPriorityReq) => request.post('/api/v1/set-allocation-priority', params)

// 해외 우선순위 API 는 gi27·gi28 이 같이 부른다 — 부른 화면코드를 헤더로 보내 감사 로그 MENU_CD 를 가른다(LOGISPRD-15645)
/** 해외 출고 우선순위 조회 */
export const getOverseasPriority = (menuCode: ScheduleMenuCode) =>
  request.post<ApiResponseV2<GetOverseasPriorityRes>>('/api/v1/get-overseas-priority', {}, menuCodeHeaders(menuCode))

/** 해외 출고 우선순위 설정 */
export const setOverseasPriority = (params: SetOverseasPriorityReq, menuCode: ScheduleMenuCode) =>
  request.post('/api/v1/set-overseas-priority', params, menuCodeHeaders(menuCode))
